<template>
  <div
    class="create-your-will-banner-container"
    :class="{ 'is-article': isArticle, 'pb-0': pb0 }"
  >
    <div class="create-your-will-banner">
      <div v-if="!alternativeBanner" class="content">
        <p>{{ bannerText }} - <span>create your will today</span></p>
        <GradientButton
          @gradientButtonClicked="createYourWill"
          title="Create My Will"
        />
      </div>
      <div v-else class="content">
        <p v-html="bannerText"></p>
        <GradientButton
          v-if="buttonText"
          @gradientButtonClicked="createYourWill"
          :title="buttonText"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateYourWillBanner",
  props: {
    isArticle: {
      required: false,
      type: Boolean,
      default: false,
    },
    bannerText: {
      required: false,
      type: String,
      default: "Secure your legacy",
    },
    alternativeBanner: {
      default: false,
      type: Boolean,
    },
    buttonText: {
      type: String,
      default: "",
    },
    pb0: {
      default: false,
      type: Boolean,
    },
  },
  computed: {},
  methods: {
    createYourWill() {
      this.$emit("createYourWill");
    },
  },
};
</script>

<style scoped lang="scss">
.create-your-will-banner-container {
  padding-top: 80px;
  padding-bottom: 80px;

  &.is-article {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .create-your-will-banner {
    box-shadow: 4px 16px 20px 0px rgba(0, 0, 0, 0.06);
    .content {
      background-color: #ffffff;
      padding: 47px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        font-family: Montserrat;
        margin: 0;
        font-size: 28px;
        font-weight: 300;
        line-height: 34px;
        letter-spacing: -0.0025em;
        text-align: center;
        margin-right: 30px;

        span {
          font-family: Montserrat;
          font-size: 28px;
          font-weight: 500;
          line-height: 34px;
          letter-spacing: -0.0025em;
        }
      }
    }
  }
}

@media only screen and (min-width: 1264px) and (max-width: 1294px) {
  .create-your-will-banner-container {
    .create-your-will-banner {
      padding-left: 140px;
      padding-right: 140px;
    }
  }
}

@media only screen and (min-width: 960px) and (max-width: 1263px) {
  .create-your-will-banner-container {
    .create-your-will-banner {
      padding-left: 80px;
      padding-right: 80px;
    }
  }
}

@media only screen and (min-width: 0px) and (max-width: 959px) {
  .create-your-will-banner-container {
    padding-top: 50px;
    padding-bottom: 50px;
    .create-your-will-banner {
      padding-left: 26px;
      padding-right: 26px;
      .content {
        flex-direction: column;
        padding: 26px;
        p {
          margin-right: 0;
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
